import infoCaloriesImg from "../../../../../../../assets/images/infoCalories.svg";
import { translate } from "../../../../../../../services/translation.service";

export const aboutLinksDictionary = [
  {
    getLabel: (): string => translate("footer.maisonDuWhisky"),
    getUrl: (): string => translate("links.whoAreWe"),
  },
  {
    getLabel: (): string => translate("footer.ourStores"),
    getUrl: (): string => translate("links.stores"),
  },
  {
    getLabel: (): string => translate("footer.companyGifts"),
    getUrl: (): string => translate("links.companyGifts"),
  },
  {
    getLabel: (): string => translate("footer.deliveryTerms"),
    getUrl: (): string => translate("links.delivery"),
  },
  {
    getLabel: (): string => translate("footer.securePayment"),
    getUrl: (): string => translate("links.securePayment"),
  },
  {
    getLabel: (): string => translate("footer.gcs"),
    getUrl: (): string => translate("links.gcs"),
  },
  {
    getLabel: (): string => translate("footer.recruitment"),
    getUrl: (): string => translate("links.recruitment"),
  },
  {
    getLabel: (): string => translate("footer.caloriesInformations"),
    getUrl: (): string => translate("links.calories"),
    imgSrc: infoCaloriesImg,
  },
];
